import React from "react";
import { useQuery } from "@apollo/react-hooks";
import GET_SEATING from "@sellout/models/.dist/graphql/queries/seating.query";
import { SeatsioClient, Region } from "seatsio";

type UseSeats = {
  client?: any;
  secretKey?: string;
  publicKey?: string;
  designerKey?: string;
  initializing: boolean;
  loading: boolean;
  error: any | undefined;
};

type UseSeatsHook = () => UseSeats;

const useSeatsHook: UseSeatsHook = () => {
  /* State */
  const [client, setClient] = React.useState();
  const [requestLoading,] = React.useState(false);

  const { data, loading, error } = useQuery(GET_SEATING, {
    onCompleted: ({ organization }) => {
      const secretKey: string = organization?.seating?.secretKey;

      setClient(new SeatsioClient(Region.EU(), secretKey));
    },
  });

  return {
    client,
    secretKey: data?.organization?.seating?.secretKey,
    publicKey: data?.organization?.seating?.publicKey,
    designerKey: data?.organization?.seating?.designerKey,
    initializing: loading,
    loading: requestLoading,
    error: error,
  };
};

export default useSeatsHook;
